import { ReactNode } from "react";

import arrowIcon from "./images/chevron-right.svg";

import styles from "./styles.module.css";

/** Component which separates breadcrumb items. */
export const BreadcrumbItemSeparator = (): ReactNode => {
  return <img className={styles.BreadcrumbItemSeparator} src={arrowIcon} alt="Separator" />;
};
